import CollaboratorAffiliationCertificate from '@/components/organisms/collaborator-affiliation-certificate/collaborator-affiliation-certificate';
import queryCertificate from '@/hooks/queryCertificate';
import GeneralPageTemplate from '@/components/template/generalPageTemplate';

const CertificadoDeAfiliacionTrabajadores = () => {
    const contentInfo = queryCertificate();
    const content = contentInfo?.referencias[0];
    const metaData = content?.metaInfo[0];
    const isActive = contentInfo?.estaActivo;
    const serviceId = content?.serviceId;

    return (
        <GeneralPageTemplate
            data={metaData}
            hasLoader={true}
            isPrivate={false}
            isActive={isActive}
            serviceId={serviceId}
        >
            <CollaboratorAffiliationCertificate contentInfo={content} />
        </GeneralPageTemplate>
    );
};

export default CertificadoDeAfiliacionTrabajadores;
